export default currencySign => value => (
    `${currencySign}${value}`
);



// WEBPACK FOOTER //
// /src/js/common/utils/formFormatters.js